<div
  class="column column_input"
  [class.column_with-error]="hasErrors">
  <crm-car-category-single-select
    class="w-full"
    styleClass="w-full"
    [isError]="$any(errors?.category)"
    [onlyTransitTaskLimitsEnabled]="true"
    [(selectedCategory)]="value.category"></crm-car-category-single-select>
  @if (errors?.category) {
    <small class="p-error">
      {{ errors.category }}
    </small>
  }
</div>

<div
  class="column column_input"
  [class.column_with-error]="hasErrors">
  <p-inputNumber
    [min]="1"
    [max]="32767"
    [(ngModel)]="value.limit"
    [ngClass]="{ 'ng-invalid ng-dirty': errors?.limit }"></p-inputNumber>
  @if (errors?.limit) {
    <small class="p-error">
      {{ errors.limit }}
    </small>
  }
</div>

<div
  class="column column_remove-button"
  [class.column_with-error]="hasErrors">
  <i
    class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
    pTooltip="Удалить строку"
    [showDelay]="500"
    tooltipPosition="top"
    style="font-size: 1.3rem"
    (click)="onDeleteClick.emit()"></i>
</div>
